import { useEffect, useState } from 'react';
import axios from 'axios';
import { MdArrowForwardIos } from 'react-icons/md';
import { calculateTotal, formatAmount, getToken } from '../utils';
import { useNavigate } from 'react-router';
import { useHistortyData } from '../TransactionHistory/useHistortyData';
import ReactLoading from 'react-loading';
import { useSearchParams } from 'react-router-dom';

const CardTransactionSummary = () => {
  const { token: userToken } = getToken();
  const userId = getToken()?.user?.id;
  const navigate = useNavigate();

  const [, setIsLoading] = useState(false);
  const [currencies, setCurrencies] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();

  const { transactionHistory, isLoading: historyDataLoading } = useHistortyData();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      const url = `${process.env.REACT_APP_BASE_URL}/dashboard/all-settings`;
      try {
        const response = await axios.get(url, {
          headers: { Authorization: `Bearer ${userToken}` },
        });

        setCurrencies(response.data.currencies);
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, [userToken]);

  const handleNavigate = (currencyId) => {
    searchParams.set('currency_id', currencyId);
    setSearchParams(searchParams);
    navigate(`/transactionhistory?currency_id=${currencyId}`);
  };

  const transactionSummaryArray = currencies.map((currency) => {
    const sellTransaction = transactionHistory
      .filter((transaction) => {
        const sellCondition =
          (transaction.originator.id === userId &&
            transaction.transaction_type.name === 'Sell') ||
          (transaction.originator.id !== userId &&
            transaction.transaction_type.name === 'Buy');
        return (
          (transaction?.quote_currency?.symbol === currency.symbol ||
            transaction?.base_currency?.symbol === currency.symbol) &&
          sellCondition &&
          transaction.transaction_status.name === 'Completed'
        );
      })
      .map((transaction) => {
        return currency.type.id === 1
          ? Number(transaction.payment.grand_total)
          : Number(transaction.payment.amount);
      });

    const buyTransaction = transactionHistory
      .filter((transaction) => {
        const buyCondition =
          (transaction.originator.id === userId &&
            transaction.transaction_type.name === 'Buy') ||
          (transaction.originator.id !== userId &&
            transaction.transaction_type.name === 'Sell');
        return (
          (transaction?.quote_currency?.symbol === currency.symbol ||
            transaction?.base_currency?.symbol === currency.symbol) &&
          buyCondition &&
          transaction.transaction_status.name === 'Completed'
        );
      })
      .map((transaction) => {
        return currency.type.id === 1
          ? Number(transaction.payment.grand_total)
          : Number(transaction.payment.amount);
      });

    let buyAmount = calculateTotal(buyTransaction);
    let sellAmount = calculateTotal(sellTransaction);

    if (currency.type.id === 1) {
      // Swap the buy and sell values for base_currency
      [buyAmount, sellAmount] = [sellAmount, buyAmount];
    }

    const buyorder = buyTransaction.length;
    const sellorder = sellTransaction.length;

    return {
      id: crypto.randomUUID(),
      sell: sellAmount,
      buy: buyAmount,
      sellorder,
      buyorder,
      totalorder: buyorder + sellorder,
      currency,
    };
  });

  return (
    <div>
      <div className='flex flex-row gap-2 justify-between pt-4 w-full overflow-auto py-1'>
        {historyDataLoading ? (
          <div>
            <ReactLoading type='cylon' color='#5AC8FA' height={44} width={44} />
          </div>
        ) : (
          transactionSummaryArray.map((transactionDetails) => {
            return (
              <div
                key={transactionDetails.id}
                className='flex flex-col gap-4 px-6 py-6 bg-p-wh border border-stone-100 min-w-[16rem] w-full shadow-lg rounded-md'
              >
                <div className='flex flex-row justify-between'>
                  <div className='flex flex-row gap-2 items-center'>
                    <img
                      src={transactionDetails?.currency?.country?.flag}
                      alt={transactionDetails?.currency?.name}
                      className='w-6 h-4'
                    />
                    <p className='font-semibold text-p-bk'>
                      {transactionDetails?.currency?.name}
                    </p>
                    <h4 className=''>transactions</h4>
                  </div>
                </div>

                <div className='flex flex-col gap-[2px] relative '>
                  <p className='text-s-bk text-sm flex flex-row  gap-1 items-center'>
                    Total orders/buy/sell:
                    <span className='text-p-bk text-base '>
                      {` ${transactionDetails.totalorder}/${transactionDetails.buyorder}/${transactionDetails.sellorder}`}
                    </span>
                  </p>
                  <p className='text-s-bk text-sm flex gap-1 flex-row items-center'>
                    Buy:{' '}
                    <span className='text-p-bk text-base '>
                      {`${transactionDetails?.currency?.symbol} ${
                        formatAmount(transactionDetails.buy) || 0
                      }`}
                    </span>
                  </p>
                  <p className='text-s-bk text-sm flex flex-row  gap-1 items-center'>
                    Sell:{' '}
                    <span className='text-p-bk text-base '>
                      {`${transactionDetails?.currency?.symbol} ${
                        formatAmount(transactionDetails.sell) || 0
                      }`}
                    </span>{' '}
                  </p>
                  <button
                    className='text-p-wh text-xs gap-2.5 absolute right-0 bottom-0 border-hf items-center hover:bg-b-mc/80 bg-b-mc rounded px-2 py-1.5 flex flex-row'
                    onClick={() =>
                      handleNavigate(transactionDetails?.currency?.id)
                    }
                  >
                    See all{' '}
                    <span className='text-b-mc bg-p-wh p-1 rounded'>
                      <MdArrowForwardIos />
                    </span>
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};
export default CardTransactionSummary;
